package com.checkin.host.util

import kotlinx.browser.window

private const val DEFAULT_API_URL = "http://localhost:8080"
private const val UNCONFIGURED_GOOGLE_CLIENT_ID = "__GOOGLE_CLIENT_ID__"
private const val UNCONFIGURED_GESTION_URL = "__GESTION_URL__"

fun apiBaseUrl(): String {
    val configured = window.asDynamic().CHECKIN_API_URL as? String
    return when {
        configured.isNullOrBlank() -> DEFAULT_API_URL
        configured == "__CHECKIN_API_URL__" -> DEFAULT_API_URL
        else -> configured.trimEnd('/')
    }
}

fun googleClientId(): String? {
    val configured = window.asDynamic().GOOGLE_CLIENT_ID as? String
    return when {
        configured.isNullOrBlank() -> null
        configured == UNCONFIGURED_GOOGLE_CLIENT_ID -> null
        else -> configured.trim()
    }
}

/** Public URL of the Gestion module (e.g. https://gestion.smartcheckin.ma). Empty = SSO link hidden. */
fun gestionUrl(): String? {
    val configured = window.asDynamic().GESTION_URL as? String
    return when {
        configured.isNullOrBlank() -> null
        configured == UNCONFIGURED_GESTION_URL -> null
        else -> configured.trimEnd('/')
    }
}

fun gestionSsoUrl(smartCheckinToken: String): String? {
    val base = gestionUrl() ?: return null
    val encoded = js("encodeURIComponent")(smartCheckinToken) as String
    return "$base/sso#token=$encoded"
}
